import { Button, DatePicker, Dropdown, Form, Input, Modal, Radio, Select, Table, Typography } from 'antd';
import { MoreOutlined, FilterOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { createCar, deleteCar, editCar, getAllCars, getCarsModels } from '../../app/api';
import { useCarContext } from '../../context/CarContext';
import moment from 'moment';
import { toast } from 'react-toastify';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const CarPage = () => {
    const { cars, setCars } = useCarContext();
    const [search, setSearch] = useState("");
    const [filterRange, setFilterRange] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFetchData, setIsFetchData] = useState(false);
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [message, setMessage ] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [isBtnDiasabled, setIsBtnDiasabled] = useState(false);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    const [allModels, setAllModels] = useState([]);
    const [selectedMake, setSelectedMake] = useState(null); 
    const [editingCars, setEditingCars] = useState(null);
    const [loading, setLoading] = useState(false);
    const [carType, setCarType] = useState(1);

    const [form] = Form.useForm();

    const showModal = () => setIsModalOpen(true);
    const showFilterModal = () => setIsFilterModalOpen(true);
    const handleFilterCancel = () => setIsFilterModalOpen(false);

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
        setSelectedMake(null);
        setMessage("");
    };

    const handleResetFilter = () => {
        setDateRange([]);
        setFilterRange([]);
    };

    const handleApplyFilter = () => {
        setFilterRange(dateRange);
        setIsFilterModalOpen(false);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        if (e.target.value === "") {
        }
    };

    const handleTableChange = (pagination) => {
        setPage(pagination.current);
        setLimit(pagination.pageSize);
    };

    const columns = [
        {
          title: '№',
          dataIndex: 'index',
          key: 'index',
          render: (text, record, index) => (page - 1) * limit + index + 1,
        },
        {
          title: 'Օգտատերի Անուն',
          dataIndex: 'username',
          key: 'username',
          render: (text, record) => (
            <span
              onClick={() => window.location.href = `/cars/${record.id}`}
              style={{ cursor: 'pointer' }}
            >
              {text}
            </span>
          )
        },
        {
          title: 'Արտադրող',
          dataIndex: 'make',
          key: 'make',
        },
        {
          title: 'Մոդել',
          dataIndex: 'model',
          key: 'model',
        },
        {
          title: 'Ավտոմեքենայի Համարանիշ',
          dataIndex: 'car_number',
          key: 'car_number',
        },
        {
            title: 'VIN Համար',
            dataIndex: 'win_number',
            key: 'win_number',
            render: (text) => <Text copyable>{text}</Text>,
        },
        {
          title: 'Ավելացման Ամսաթիվ',
          dataIndex: 'createdAt',
          key: 'createdAt',
          render: (text) => new Date(text).toLocaleDateString(),
        },
        {
          title: "Գործողություններ",
          key: "actions",
          align: "center",
          render: (_, record) => {
            const menuItems = [
              {
                key: "edit",
                label: "✏️ Խմբագրել",
                onClick: () => onEdit(record),
              },
              {
                key: "delete",
                label: "🗑️ Ջնջել",
                danger: true,
                onClick: () => onDelete(record.id),
              },
            ];
      
            return (
              <Dropdown menu={{ items: menuItems }} trigger={["click"]} placement="bottomRight">
                <Button type="text" icon={<MoreOutlined />} />
              </Dropdown>
            );
          },
        },
    ];
    
    const onEdit = (car) => {
        setEditingCars(car);
        const formattedDate = moment(car.createdAt, "YYYY-MM-DD HH:mm:ss");
        if (!formattedDate.isValid()) {
            console.error('Invalid date format');
            return;
        }

        setSelectedMake(car.make);
        form.setFieldsValue({
            username: car.username,
            make: car.make,
            model: car.model,
            car_number: car.car_number,
            win_number: car.win_number,
            user_mobile_number: car.user_mobile_number,
            createdAt: formattedDate 
        });
        setIsModalOpen(true);
    };

    const onDelete = (id) => {
        Modal.confirm({
          title: 'Դուք համոզվա՞ծ եք',
          okText: 'Այո',
          okType: 'danger',
          cancelText: 'Ոչ',
          onOk: async () => {
            try {
              const result = await deleteCar(id);
              if (result.status === 200) {
                setCars(prevCar => prevCar.filter(item => item.id !== id));
                getCars();
              }
            } catch (error) {
              console.error('Error deleting transaction:', error);
            }
          },
          onCancel() {
            console.log('Delete operation canceled');
          },
        });
    };

    const handleAdd = async (values) => {
        setIsBtnDiasabled(true);
        try {
            const newData = {
              ...values,
              createdAt: values.createdAt.format('YYYY-MM-DD HH:mm:ss'),
              car_number: values.car_number.toUpperCase()
            };
        
            setIsFetchData(true);
            let response;
            if (editingCars) {
                response = await editCar(editingCars.id, newData);
            } else {
                response = await createCar(newData);
            }
            
            if (response.status === 200 || response.status === 201) {
                setIsModalOpen(false);
                setIsFetchData(false);
                form.resetFields();
                setEditingCars(null);
                setMessage("");
                getCars();
            } else if (response.statusCode === 400) {
                toast.error(response.message);
                setMessage(response.message);
            }
        } catch(err) {
            console.log("Error", err)
        } finally {
            setIsBtnDiasabled(false);
        }
    };

    const getCars = async () => {
        setLoading(true);
        const data = {
          search,
          startDate: dateRange.length ? dateRange[0].format("YYYY-MM-DD") : "",
          endDate: dateRange.length ? dateRange[1].format("YYYY-MM-DD") : "",
          page,
          limit
        }
        const allData = await getAllCars(data);
        const all_cars = allData?.data;
        
        if (allData?.status === 200) {
            setCars(all_cars?.data);
            setTotal(all_cars.total);
            setLoading(false);
            if (all_cars?.data.length === 0 && !search) {
                setDisabled(true);
            } else {
                setDisabled(false)
            }
        }
    };

    const allCarsModelsData = async () => {
        const allModelsData = await getCarsModels();
        const car_data = allModelsData.data;
        if (allModelsData.status === 200) {
            setAllModels(car_data.data);
        }
    };

    const carNumberValidator = (value) => {
        const firstPart = /^[0-9]{2}/;
        const secondPart = /^[A-Z]{2}/;
        const thirdPart = /^[0-9]{3}$/;
    
        if (value) {
            const upperCaseValue = value.toUpperCase();
            
            if (!firstPart.test(upperCaseValue.slice(0, 2))) {
                return Promise.reject('Առաջին երկու բնագավառները պետք է լինեն թվեր');
            }
            
            if (!secondPart.test(upperCaseValue.slice(2, 4))) {
                return Promise.reject('Երկու հաջորդ բնագավառները պետք է լինեն մեծատառեր');
            }
            
            if (!thirdPart.test(upperCaseValue.slice(4, 7))) {
                return Promise.reject('Վերջին երեք բնագավառները պետք է լինեն թվեր');
            }
        }
    
        return Promise.resolve();
    };

    const carGoverNumberValidator = (value) => {
        const firstPart = /^[0-9]{3}/;
        const secondPart = /^[A-Z]{2}/;
        const thirdPart = /^[0-9]{2}$/;
    
        if (value) {
            const upperCaseValue = value.toUpperCase();
            
            if (!firstPart.test(upperCaseValue.slice(0, 3))) {
                return Promise.reject('Առաջին երեք բնագավառները պետք է լինեն թվեր');
            }
            
            if (!secondPart.test(upperCaseValue.slice(3, 5))) {
                return Promise.reject('Երկու հաջորդ բնագավառները պետք է լինեն մեծատառեր');
            }
            
            if (!thirdPart.test(upperCaseValue.slice(5, 7))) {
                return Promise.reject('Վերջին երկու բնագավառները պետք է լինեն թվեր');
            }
        }
    
        return Promise.resolve();
    };
    
    const validateVin = (vin) => {
        const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
        if (!vinRegex.test(vin)) {
            return 'Սխալ VIN համարը։ Այն պետք է լինի 17 նշան և պարունակի միայն թույլատրված նշաններ։';
        }
        return 'VIN համարը ճիշտ է։';
    };

    useEffect(() => {
        allCarsModelsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (search) {
          const delayDebounceFn = setTimeout(() => {
            getCars();
          }, 500);
          return () => clearTimeout(delayDebounceFn);
        } else {
          getCars();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, page, filterRange, isFetchData]);
    
    return (
        <div style={{ padding: 20 }}>
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                <Input
                    placeholder="Որոնել..."
                    prefix={<SearchOutlined />}
                    disabled={disabled}
                    value={search}
                    onChange={handleSearchChange}
                    allowClear
                    style={{ width: 200 }}
                />
                <Button icon={<FilterOutlined />} onClick={showFilterModal}>
                    Ֆիլտր
                </Button>
                {filterRange.length > 0 && (
                    <Button icon={<ReloadOutlined />} onClick={handleResetFilter}>
                        Մաքրել ֆիլտրը
                    </Button>
                )}
                <Button type="primary" onClick={showModal}>
                    Ավելացնել
                </Button>
            </div>

            <Modal title="Ֆիլտր" open={isFilterModalOpen} onCancel={handleFilterCancel} footer={null}>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <RangePicker format="YYYY-MM-DD" value={dateRange.length ? dateRange : null} onChange={(dates) => setDateRange(dates || [])} placeholder={["Սկիզբ", "Վերջ"]} />
                <Button type="primary" onClick={handleApplyFilter} block>
                    Հաստատել
                </Button>
                </div>
            </Modal>

            <Table
                columns={columns}
                dataSource={cars}
                rowKey="id"
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: total
                }}
                scroll={{ x: 'max-content' }}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal
                title="Ավելացնել մեքենա"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form layout="vertical" onFinish={handleAdd} form={form}>
                    <Form.Item
                        label="Օգտատերի Անուն"
                        name="username"
                        rules={[{ required: true, message: 'Խնդրում ենք լրացնել անվանումը' }]}
                    >
                        <Input placeholder="Օրինակ՝ Աշոտ" />
                    </Form.Item>
                    <Form.Item
                        label="Օգտատերի Հեռախոսահամարը"
                        name="user_mobile_number"
                        rules={[
                            { required: true, message: 'Խնդրում ենք լրացնել հեռախոսահամարը' },
                            {
                                validator: (_, value) => {
                                    const armenianPhoneRegex = /^(?:\+374|0)(10|11|33|41|43|44|46|49|55|77|91|93|94|95|96|97|98|99)\d{6}$/;
                                    if (!value || armenianPhoneRegex.test(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Խնդրում ենք մուտքագրել վավեր հայկական հեռախոսահամար'));
                                }
                            }
                        ]}
                    >
                        <Input 
                            maxLength={12}
                            placeholder="Օրինակ՝ 077123456 կամ +37477123456"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Արտադրող"
                        name="make"
                        rules={[{ required: true, message: 'Խնդրում ենք ընտրել արտադրողը' }]}
                    >
                        <Select
                            showSearch
                            placeholder="Ընտրել արտադրող"
                            optionFilterProp="children"
                            onChange={(value) => {
                                setSelectedMake(value);
                                form.setFieldsValue({ model: undefined });
                            }}
                            filterOption={(input, option) =>
                                option?.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {allModels.map((item) => (
                                <Select.Option key={item.id} value={item.brand}>
                                    {item.brand}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Մոդել"
                        name="model"
                        // rules={[{ required: true, message: 'Խնդրում ենք ընտրել մոդելը' }]}
                    >
                        <Select 
                            showSearch
                            placeholder="Ընտրել մոդել"
                            disabled={!selectedMake}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option?.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {selectedMake &&
                                allModels
                                    .find((item) => item.brand === selectedMake)
                                    ?.models.map((model, index) => (
                                        <Select.Option key={index} value={model}>
                                            {model}
                                        </Select.Option>
                                    ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Տեսակ" name="car_type" initialValue={1}>
                    <Radio.Group
                        onChange={(e) => {
                            const value = e.target.value;
                            setCarType(value);
                            form.setFieldsValue({ car_number: '' });
                        }}
                        value={carType}
                    >
                            <Radio value={1}>Անձնական</Radio>
                            <Radio value={2}>Պետական</Radio>
                            <Radio value={3}>Այլ</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item
                        label="Մեքենայի համարանիշ"
                        name="car_number"
                        rules={[
                            { required: true, message: 'Խնդրում ենք լրացնել պետհամարանիշը' },
                            {
                                validator: async (_, value) => {
                                    if (carType === 1) {
                                        await carNumberValidator(value);
                                    } else if (carType === 2) {
                                        await carGoverNumberValidator(value)
                                    }
                                },
                            },
                        ]}
                    >
                        <Input 
                            placeholder={carType === 1 ? "Օրինակ՝ 13AB666" : carType === 2 ? "Օրինակ՝ 666AB13" : "Օտարերկրյա համար"}
                            style={{ textTransform: 'uppercase' }}
                            maxLength={7}
                            onChange={(e) => {
                                let value = e.target.value.toUpperCase();
                                if (/[^A-Z0-9]/.test(value)) {
                                    value = value.replace(/[^A-Z0-9]/g, '');
                                }

                                if (value.length <= 8) {
                                    e.target.value = value;
                                }
                            }}
                         />
                    </Form.Item>
                    
                    <Form.Item
                        label="VIN համար"
                        name="win_number"
                        rules={[
                            { required: true, message: 'Խնդրում ենք լրացնել VIN համարը' },
                            {
                                validator: async (_, value) => {
                                  await validateVin(value);
                                },
                            },
                        ]}
                    >
                        <Input
                            placeholder="Օրինակ՝ JM1GJ1U62E1423456"
                            onChange={(e) => {
                                const upperValue = e.target.value.toUpperCase();
                                form.setFieldsValue({ win_number: upperValue });
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Ամսաթիվ"
                        name="createdAt"
                        rules={[{ required: true, message: 'Խնդրում ենք լրացնել ամսաթիվը' }]}
                    >
                        <DatePicker 
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Օրինակ՝ 2025-03-14 12:05:50"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button disabled={isBtnDiasabled} type="primary" htmlType="submit" block>
                            Ավելացնել
                        </Button>
                    </Form.Item>
                    {message && (
                        <div
                        style={{
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                        }}
                        >
                         {message}
                        </div>
                    )}
                </Form>
            </Modal>
        </div>
    );
};

export default CarPage;
